import Button from "components/Button";
import Grid from "components/Grid";
import Loader from "components/Loader";
import Text from "components/Text";
import TextInput from "components/TextInput";
import PageContent from "pages/PageContent";
import {
    ProfileContentWrapper,
    StraightLine,
    SubHeading,
} from "pages/PageContent/PageContent.styled";
import { FC, useEffect } from "react";
import { BsArrowRight } from "react-icons/bs";
import { FiLoader } from "react-icons/fi";
import theme from "theme";
import { TextAreaWrapper } from "../../OtherInterests/OtherInterests.styled";
import {
    Circle,
    FileInput,
    FileInputLabel,
    FileInputWrapper,
    GreyText,
} from "./CompanyDetails.styles";
import { useCompanyDetails } from "./useCompanyDetails";

export const CompanyDetails: FC = () => {
    const {
        inputErrors,
        inputs,
        handleInputChange,
        handleSubmit,
        isLoading,
        navigateToNextPage,
        handleFileUpload,
        profileUrl,
        isFetchingData,
        isUploadingFile,
    } = useCompanyDetails();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
    return (
        <PageContent>
            <ProfileContentWrapper>
                {isFetchingData && <Loader size={28} />}
                <Text
                    variant="heading5"
                    fontWeight="700"
                    color={theme.colors.grey.dark}
                >
                    Complete Your Profile (1/3)
                </Text>
                <SubHeading variant="label">
                    Company Details <StraightLine />
                </SubHeading>
                <GreyText variant="body1">Upload Company Logo</GreyText>
                <FileInputWrapper>
                    <Circle profileUrl={profileUrl}>
                        {isUploadingFile && <FiLoader />}
                    </Circle>
                    <FileInputLabel htmlFor="company-logo">
                        <FileInput
                            id="company-logo"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg, image/HEIC"
                            onChange={handleFileUpload}
                        />
                        Change
                    </FileInputLabel>
                </FileInputWrapper>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <TextInput
                        name="companyName"
                        label="Company Name"
                        required
                        placeholder="Enter Company Name"
                        labelColor={theme.colors.text}
                        minWidth="500px"
                        value={inputs.companyName}
                        errorMsg={inputErrors.companyName}
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid
                    row={true}
                    expanded
                    marginTop={2}
                    columnGap={1}
                    rowGap={1}
                >
                    <TextInput
                        name="websiteUrl"
                        label="Website URL"
                        required
                        placeholder="Enter Website URL"
                        labelColor={theme.colors.text}
                        minWidth="500px"
                        value={inputs.websiteUrl}
                        errorMsg={inputErrors.websiteUrl}
                        onChange={handleInputChange}
                    />
                </Grid>
                <Grid row expanded>
                    <TextAreaWrapper>
                        <TextInput
                            name="aboutCompany"
                            multiLine
                            required
                            minWidth="500px"
                            label="About Company"
                            value={inputs.aboutCompany}
                            errorMsg={inputErrors.aboutCompany}
                            onChange={handleInputChange}
                        />
                    </TextAreaWrapper>
                </Grid>
                <Grid
                    row={true}
                    columnGap={1}
                    marginTop={3}
                    marginBottom={1}
                    rowGap={1}
                >
                    <Button
                        variant="outlined"
                        isLoading={!navigateToNextPage && isLoading}
                        onClick={() => handleSubmit(false)}
                    >
                        Save
                    </Button>
                    <Button
                        icon={<BsArrowRight />}
                        isLoading={navigateToNextPage && isLoading}
                        onClick={() => handleSubmit(true)}
                    >
                        Save & Next
                    </Button>
                </Grid>
            </ProfileContentWrapper>
        </PageContent>
    );
};
